/**
 * Created by JackCui on 2021/4/19
 */

const TYPE_MAP = {
  STATE: 'state',
  METHOD: 'method'
}

class Store {
  static modules = {}

  // 解析module
  install (modules) {
    for (let v in modules) {
      // 相同的module不做处理
      if (!modules.hasOwnProperty(v) || this[v]) {
        continue
      }

      if (!Store.modules[v]) {
        Store.modules[v] = {}
      }

      this.forEachState(v, modules[v].state)

      this.forEachMethods(v, modules[v].methods)

      this[v] = (name) => {
        return this.registerReturn(v, name)
      }
    }
  }

  // 初始state
  forEachState (key, states) {
    for (let v in states) {
      if (!states.hasOwnProperty(v)) {
        continue
      }

      this.register(key, v, states[v], TYPE_MAP.STATE)
    }
  }

  // 初始methods
  forEachMethods (key, methods) {
    for (let v in methods) {
      if (!methods.hasOwnProperty(v)) {
        continue
      }

      this.register(key, v, methods[v], TYPE_MAP.METHOD)
    }
  }

  // 将state methods注册到Store
  register (key, v, value, type) {
    if (!Store.modules[key][v]) {
      Store.modules[key][v] = {}
    }

    let newValue = value
    // 非可注册结构
    if (!newValue.handle) {
      newValue = {
        handle: value,
        timeout: null
      }
    }

    const {handle, timeout} = newValue

    Store.modules[key][v] = {
      type,
      handle,
      timeout,
      params: null,
      promise: null,
      lastTime: null,
      refresh: null
    }
  }

  registerReturn (key, name) {
    return {
      getter: async (param, force) => {
        return new Promise(async resolve => {
          const {
            handle,
            promise,
            timeout,
            params: moduleParams,
            lastTime,
            refresh
          } = Store.modules[key][name]

          if (
            promise &&
            !force &&
            !refresh &&
            this.failureTime(lastTime, timeout) &&
            JSON.stringify(param || '{}') === JSON.stringify(moduleParams || '{}')
          ) {
            return resolve(promise)
          }

          const handleValue = typeof handle === 'function' ? handle(param) : handle

          Store.modules[key][name] = {
            ...Store.modules[key][name],
            promise: handleValue,
            params: param,
            lastTime: new Date().getTime(),
            refresh: null
          }

          resolve(handleValue)
        })
      },
      update: (val) => {
        const {type} = Store.modules[key][name]

        if (type === TYPE_MAP.METHOD) {
          throw new Error('Invalid operation')
        }

        this.register(key, name, val)
      },
      refresh () {
        Store.modules[key][name].refresh = true
      }
    }
  }

  failureTime (lastTime, timeout) {
    const newTime = new Date().getTime()
    return (!timeout || newTime - lastTime < (timeout * 1e3))
  }

  remove (key, name) {
    if (name) {
      return delete Store.modules[key][name]
    }

    delete Store.modules[key]
  }

  isPromise (val) {
    return val && typeof val.then === 'function'
  }
}

export default new Store()
